<template>
  <v-dialog
    v-model="dialog"
    hide-overlay
    persistent
    :width="width"
  >
    <v-card
      flat
      tile
      class="grey lighten-3"
    >
      <v-toolbar
        dense
        light
        class="grey lighten-2"
      >
        <v-toolbar-title class="text-body-1 font-weight-bold grey--text text--darken-2">
          {{ dialogTitle }}
        </v-toolbar-title>

        <v-card
          flat
          tile
          class="d-flex align-center ml-16"
          color="transparent"
        >
          <div class="mr-3 font-weight-bold font-italic">
            {{ $t('m.estiName') + ':' }}
          </div>
          <v-text-field
            v-model="EstiTitle"
            style="width:260px;"
            dense
            hide-details="true"
          />
        </v-card>

        <v-spacer />
        <v-btn
          icon
          color=""
          @click="handleCancel"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <v-progress-linear
          :active="isLoading"
          :indeterminate="isLoading"
          absolute
          bottom
          color="deep-purple accent-4"
        />
      </v-toolbar>
      <v-divider />

      <v-card
        class="pa-3 grey lighten-3"
        flat
        tile
        :height="workspaceCardHeight"
        style="overflow-y:auto;"
      >
        <v-card
          flat
          tile
          :disabled="viewFlag"
        >
          <v-row dense>
            <v-col cols="9">
              <CargoPane
                :edit-flag="editFlag"
                :model="model"
              />
              <PortRotationForm
                :edit-flag="editFlag"
                :model="model"
              />
              <VesselParticularPad
                :edit-flag="editFlag"
                :model="model"
              />
            </v-col>
            <v-col cols="3">
              <CostPad
                :edit-flag="editFlag"
                :model="model"
              />
              <ResultPad
                :edit-flag="editFlag"
                :model="model"
              />
              <v-card
                class="d-flex justify-space-around px-1 pt-1 pb-1 mt-1"
                color="grey lighten-5"
              >
                <v-btn
                  depressed
                  color="brown lighten-4"
                  @click="handleCancel"
                  :disabled="isLoading"
                >
                  {{ $t('m.cancel') }}
                </v-btn>
                <v-btn
                  depressed
                  color="primary"
                  class=""
                  @click="save"
                  :disabled="isLoading"
                >
                  <v-icon
                    small
                    class="mr-2"
                  >
                    mdi-content-save
                  </v-icon> {{ $t('m.save') }}
                </v-btn>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-card> <!-- end workspace -->
    </v-card> <!-- end 最外层 card -->

    <v-snackbar
      v-model="snackbar"
      centered
    >
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="pink"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          {{ $t('m.close') }}
        </v-btn>
      </template>
    </v-snackbar>

    <AlertConfirmDlg
      :visible="alertConfirmDlgVisible"
      :content="alertContent"
      @cancel="cancelAlertDlg"
      @confirm="confirmAlertDlg"
    />

    <v-overlay :value="isLoading" />
  </v-dialog>
</template>

<script>
import _ from 'lodash'
import dayjs from 'dayjs'
import { mapState, mapGetters } from 'vuex'
import Utils from '@/utils/index'
import httpClient from '@/api/httpClient'
import Constant from '@/constant'
import CargoPane from '@/components/estimation/CargoPane'
import PortRotationForm from '@/components/estimation/PortRotationForm'
import VesselParticularPad from '@/components/estimation/VesselParticularPad'
import CostPad from '@/components/estimation/CostPad'
import ResultPad from '@/components/estimation/ResultPad'
import AlertConfirmDlg from '@/components/AlertConfirmDlg'

export default {
  name: 'EstimationEditDialog',
  components: {
    CargoPane, PortRotationForm, VesselParticularPad, CostPad, ResultPad, AlertConfirmDlg
  },
  props: [
    'visible', 'estiID', 'viewFlag'
  ],
  data () {
    return {
      dialog: false,
      dialogTitle: null,

      editFlag: false,
      value: [0, 1],
      isFound: false,
      isLoading: false,
      model: null,
      EstiTitle: null,

      snackbar: false,
      snackbarText: null,

      alertConfirmDlgVisible: false,
      alertContent: ''
    }
  },
  computed: {
    ...mapState({
      currEditEsti: state => state.estimating.currEditEsti,
      isRotating: state => state.estimating.isRotating,
      isGettedDistance: state => state.estimating.isGettedDistance,
      shipInfo: state => state.estimating.shipInfo,
      cargoTabsArr: state => state.estimating.cargoTabsArr,
      portsRotationArr: state => state.estimating.portsRotationArr,

      originRoutes: state => state.estiDistance.originRoutes,
      requiredWayPointArr: (state) => state.estiDistance.requiredWayPointArr

    }),
    ...mapGetters({
      ttlVoyDays: 'getTtlVoyDays',
      ttlSeaDays: 'getTtlSeaDays',
      ttlPortIdleDays: 'getTtlPortIdleDays',
      ttlPortWorkDays: 'getTtlPortWorkDays',

      ttlAddComm: 'getAddCommRateVal',
      ttlBrokerage: 'getBrokerageRateVal',
      ttlFrtTax: 'getFrtTax',
      ttlPortCharge: 'getPortCharge',

      fuelConsumption: 'getFuelConsumption',
      fuelCost: 'getFuelCost',
      getRent: 'getRent',
      getRentAndCom: 'getRentAndCom',
      getOpExpense: 'getOpExpense',

      getHireLevelPerDay: 'getHirePerDay',
      getOpProfit: 'getOpProfit',
      getProfit: 'getProfit',
      getTtlRevenue: 'getTtlRevenue',
      getTtlExpense: 'getTtlExpense'
    }),

    width () {
      switch (this.$vuetify.breakpoint.name) {
        case 'sm': return 958
        case 'md': return 1236
        case 'lg': return 1380
        case 'xl': return 1580
      }
    },
    workspaceCardHeight () {
      if (this.$vuetify.breakpoint.height > 859) {
        return 'auto'
      }
      return this.$vuetify.breakpoint.height - 150
    },
    heightClassObj () {
      return {
        lgOnlyHeight: this.$vuetify.breakpoint.lgOnly,
        mdAndDownHeight: this.$vuetify.breakpoint.mdAndDown
      }
    }
  }, // end computed
  watch: {
    visible: function (val) {
      this.model = null
      this.EstiTitle = null
      if (val) {
        this.$store.commit('setClearFlag', false)

        if (this.estiID) {
          this.dialogTitle = this.$t('m.editEsti')
          this.editFlag = true
          this.query(this.estiID)
        } else { //
          this.dialogTitle = this.$t('m.addEsti')
          this.$store.commit('resetEstimatingEmpty')
          this.$store.commit('clearDistanceForEsti')
          this.editFlag = false
        }
      }
      this.dialog = val
    }
  },
  created () {

  },
  mounted () {
  },
  methods: {
    handleCancel () {
      if (this.isRotating && !this.model) {
        this.alertConfirmDlgVisible = true
        this.alertContent = this.$t('m.comfirmQuit')
      } else {
        this.$emit('cancel')
        this.EstiTitle = null
        this.$store.commit('setClearFlag', true)
        this.$store.commit('clearDistanceForEsti')
      }
    },
    cancelAlertDlg () {
      this.alertConfirmDlgVisible = false
    },
    confirmAlertDlg () {
      this.alertConfirmDlgVisible = false
      this.$emit('cancel')
      this.EstiTitle = null
      this.$store.commit('setClearFlag', true)
      this.$store.commit('clearDistanceForEsti')
    },

    query (estiID) {
      this.isLoading = true
      var json = {
        OperID: Utils.getWithExpiry('operID'),
        EstiID: estiID
      }
      httpClient.post('/ATVoyageEstiQry', json)
        .then((res) => {
          if (res.data.length > 0) {
            this.isFound = true
            this.model = res.data[0]
            this.EstiTitle = this.model.ESTITITLE
            console.log(this.model)
            this.resetParticularState()
            this.resetCostState()
          } else {
            this.isFound = false
            this.model = null
          }
          this.isLoading = false
        }).catch((err) => {
          this.isLoading = false
        })
    },

    save () {
      if (!_.trim(this.EstiTitle)) {
        this.snackbar = true
        this.snackbarText = this.$t('m.estiNameRequired')
        return
      }

      if (this.cargoTabsArr.length == 0) {
        this.snackbar = true
        this.snackbarText = this.$t('m.littleCargoInfo')
        return
      }

      for (var i = 0; i < this.cargoTabsArr.length; i++) {
        var cargo = this.cargoTabsArr[i]
        if (this._.trim(cargo.Cargo) === '' ||
            cargo.LoadPort.portId.length == 0 || cargo.DischargePort.portId.length == 0) {
          this.snackbar = true
          this.snackbarText = this.$t('m.littleCargoInfo')
          return
        }
      }

      if (this.portsRotationArr.length < 2) {
        this.snackbar = true
        this.snackbarText = this.$t('m.noGeneratePortList')
        return
      }

      //
      this.isLoading = true
      var vesselData = {}; var cargoData = []; var portData = {}
      var resultData = {}; var hireData = {}

      this.cargoTabsArr.forEach((ele, index) => {
        const cargo = _.cloneDeep(ele)
        cargo.Revenue = cargo.Income
        cargo.From = cargo.LoadPort.portId
        cargo.FromName = cargo.LoadPort.fullName
        cargo.To = cargo.DischargePort.portId
        cargo.ToName = cargo.DischargePort.fullName

        cargo.LoadPort = {}
        cargo.DischargePort = {}
        cargoData.push(cargo)
      })

      portData.departureDate = ''
      // portData.excRouteStr = this.excRoutePoint.join(",")
      portData.prevPort = ''
      portData.prevPortName = ''
      portData.marginSeaDays = this.$store.state.estimating.marginSeaDay
      portData.marginIdleDays = this.$store.state.estimating.marginIdleDay
      portData.marginWorkDays = this.$store.state.estimating.marginWorkDay
      portData.txtTTLDays = this.ttlVoyDays
      portData.portOrder = []
      this.portsRotationArr.forEach((ele, index) => {
        const tmplPort = {}
        if (ele.arrived) {
          if (index == 0 && _.isDate(ele.arrived)) {
            tmplPort.ArrivalDate = ele.arrived.getTime()
          } else {
            tmplPort.ArrivalDate = ele.arrived
          }
        } else { tmplPort.ArrivalDate = '' }

        tmplPort.DepartureDate = ele.departed ? ele.departed : ''

        tmplPort.Distance = _.toNumber(ele.distance)
        tmplPort.SeaDays = ele.seaDays
        tmplPort.PortID = ele.port.portId
        tmplPort.PortName = ele.port.fullName
        tmplPort.PortLon = ele.port.longitude
        tmplPort.PortLat = ele.port.latitude
        tmplPort.PortIdleDays = ele.idleDays
        tmplPort.PortWorkDays = ele.workDays
        tmplPort.PortCharge = ele.portCharge
        tmplPort.TaskType = _.toNumber(ele.taskType)
        tmplPort.taskTypeName = ele.taskTypeName

        tmplPort.cargoUid = ele.portSeqInCargos + ''
        tmplPort.no = ele.portSeq

        portData.portOrder.push(tmplPort)
      })

      // console.log(portData.portOrder);
      vesselData = this.shipInfo

      resultData.HirePerDay = this.$store.state.estimating.HirePerDay // 日租金
      resultData.HireDay = this.getRent // 租金
      resultData.HireCommPercent = this.$store.state.estimating.HireCommPercent // 租金佣金 比率
      resultData.HireComm = this.getRentAndCom // 租金佣金

      resultData.Demurrage = this.$store.state.estimating.Demurrage
      resultData.Dispatch = this.$store.state.estimating.Dispatch
      resultData.ILOHC = this.$store.state.estimating.ILOHC
      resultData.BallastBonus = this.$store.state.estimating.BallastBonus
      resultData.CEV = this.$store.state.estimating.CEV
      resultData.OpOther = this.$store.state.estimating.OpOther

      resultData.AddComm = this.ttlAddComm
      resultData.Brokerage = this.ttlBrokerage
      resultData.FreightTax = this.ttlFrtTax

      resultData.PortCharge = this.ttlPortCharge
      resultData.PortIdleDays = this.ttlPortIdleDays
      resultData.PortWorkDays = this.ttlPortWorkDays
      resultData.SeaDays = this.ttlSeaDays
      resultData.TTLDays = this.ttlVoyDays

      resultData.FOPrice = this.$store.state.estimating.foPrice
      resultData.DOPrice = this.$store.state.estimating.doPrice

      resultData.FOConsumption = this.fuelConsumption.foConsump
      resultData.FOExpense = this.fuelCost.foFee
      resultData.DOConsumption = this.fuelConsumption.doConsump
      resultData.DOExpense = this.fuelCost.doFee

      resultData.getOpExpense = this.getOpExpense // 航次成本
      resultData.OpProfit = this.getOpProfit // 航次净利润
      resultData.Profit = this.getProfit // 期租收入
      resultData.TTLExpense = this.getTtlExpense // 航次费用
      resultData.TTLRevenue = this.getTtlRevenue // 航次收入
      resultData.HireLevelPerDay = this.getHireLevelPerDay // 日租金水平

      hireData.hireComm = resultData.HireComm
      hireData.hireCommPercent = resultData.HireCommPercent

      var mycontent = {
        cargoData: cargoData,
        portData: portData,
        vesselData: vesselData,
        routePoints: this.originRoutes,
        requiredWayPointArr: this.requiredWayPointArr,
        hireData: hireData,
        resultData: resultData

      }

      var json = {
        OperID: Utils.getWithExpiry('operID'),
        EstiID: this.model ? this.model.ESTIID : '',
        ShipID: '',
        EstiTitle: this.EstiTitle,
        EstiDesc: this.EstiTitle,
        EstiContent: JSON.stringify(mycontent),
        Remark: ''
      }

      httpClient.post('/ATEstiMod4Mobile', json)
        .then((res) => {
          this.isLoading = false
          this.$emit('save')
          this.EstiTitle = null
          this.$store.commit('setClearFlag', true)
          this.$store.commit('clearDistanceForEsti') //
        }).catch((err) => {
          this.isLoading = false
        })
    },

    resetParticularState () {
      this.$store.commit('updateEstiShipInfo', this.model.ESTICONTENT.vesselData)
      this.$store.commit('setFuelPrice', {
        foPrice: this.model.ESTICONTENT.resultData.FOPrice,
        doPrice: this.model.ESTICONTENT.resultData.DOPrice
      })
    },

    resetCostState () {
      var resultData = this.model.ESTICONTENT.resultData
      var costInfo = {
        HirePerDay: resultData.HirePerDay,
        HireCommPercent: resultData.HireCommPercent,
        Demurrage: resultData.Demurrage,
        Dispatch: resultData.Dispatch,
        ILOHC: resultData.ILOHC,
        BallastBonus: resultData.BallastBonus,
        OpOther: resultData.OpOther,
        CEV: resultData.CEV
      }
      this.$store.commit('setCostInfo', costInfo)
    }

  }
}
</script>

<style scoped lang="scss">
  .lgOnlyHeight {
    max-height: 600px; overflow-y: auto;
  }
  .mdAndDownHeight {
    max-height: 520px; overflow-y: auto;
  }

</style>
